__turbopack_context__.v({
  "arrow": "styles-module-scss-module__ZYiD8W__arrow",
  "chevron": "styles-module-scss-module__ZYiD8W__chevron",
  "cover": "styles-module-scss-module__ZYiD8W__cover",
  "menu": "styles-module-scss-module__ZYiD8W__menu",
});
